import Env from './env.config';

export const env = new Env();
